module.exports = __webpack_public_path__ + "static/img/station.3a86d582.png";